import * as types from './mutation-types'
import axios from '../http'
import qs from 'qs'
import Config from '../config/config'

export default {
  // 设置token
  login(context, payload) {
    context.commit(types.LOGIN, payload)
  },
  setPhone(context, payload) {
    context.commit(types.SET_PHONE, payload)
  },
  enableJssdk(context) {
    context.commit(types.ENABLE_JSSDK)
  },
  disableJssdk(context) {
    context.commit(types.DISABLE_JSSDK)
  },
  setAddress(context, payload) {
    context.commit(types.SET_ADDRESS, payload)
  },
  setAwarded(context) {
    context.commit(types.SET_AWARDED)
  },
  getLocation(context, payload) {
    // 判断是否已获取定位了，用户可能拒绝了
    if (payload.longitude & payload.latitude) {
      // 初始化，避免重复请求
      context.commit(types.GET_LOCATION, {})
      // 请求高德接口，获取位置信息
      const gaodeUrl = 'https://restapi.amap.com/v3/geocode/regeo'
      const params = {
        key: Config.gaodeApiKey,
        location: payload.longitude + ',' + payload.latitude
      }
      axios.get(gaodeUrl, { params: params, withCredentials: false }).then(function(res) {
        // 添加省市区编码数据，用以溯源
        let location
        if (res.status === '1') {
          location = {
            longitude: payload.longitude, latitude: payload.latitude,
            district: res.regeocode.addressComponent.district,
            province: res.regeocode.addressComponent.province,
            city: res.regeocode.addressComponent.city
          }
          // location.address = location.province + location.city + location.district + res.regeocode.addressComponent.township
          location.address = res.regeocode.formatted_address
          const adcode = res.regeocode.addressComponent.adcode
          location.district_code = adcode
          location.city_code = adcode.substr(0, 4) + '00'
          location.province_code = adcode.substr(0, 2) + '0000'
        } else {
          location = {
            longitude: payload.longitude, latitude: payload.latitude
          }
        }
        context.commit(types.GET_LOCATION, location)
      })
    } else {
      // 未定位成功就设置经纬度为空
      const location = {
        longitude: '', latitude: ''
      }
      context.commit(types.GET_LOCATION, location)
    }
  },
  scanQrcode({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      // 初始化，避免重复请求
      commit(types.SCAN_QRCODE, {})
      // 调用扫码接口
      var params = {
        serial: payload.serial,
        latitude: state.location.latitude,
        longitude: state.location.longitude,
        province: state.location.province,
        city: state.location.city,
        district: state.location.district,
        location: state.location.address,
        province_code: state.location.province_code,
        city_code: state.location.city_code,
        district_code: state.location.district_code
      }
      axios.post('/qrcode/scan/', qs.stringify(params)).then(function(res) {
        if (!res.code) {
          commit(types.SCAN_QRCODE, res.data)
          resolve()
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  /**
   * 获取店主的openid(针对用户在国花瓷盟友服务公众号)
   * @param {*} param
   * @param {*} payload
   */
  getShopOpenId({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload.code)
      axios.get('/shop/wx_openid/?code=' + payload.code).then(res => {
        if (!res.code) {
          commit(types.SET_SHOP_OPENID, res.data)
          resolve()
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js